const params = new URLSearchParams(window.location.search);
const gclid = params.get('gclid');
const wbraid = params.get('wbraid');
const gbraid = params.get('gbraid');
const gclidData = gclid || wbraid || gbraid;
if (gclidData) {
  localStorage.setItem('gclid', gclidData);
}
